<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="buttons--row mb-4 justify-content-between">
                        <div class="filter-wrap">
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.day"
                                    @change="getListInfo"
                                >
                                    <option value="all">Select One</option>
                                    <option value="monday">Monday</option>
                                    <option value="tuesday">Tuesday</option>
                                    <option value="wednesday">Wednesday</option>
                                    <option value="thursday">Thursday</option>
                                    <option value="friday">Friday</option>
                                    <option value="saturday">Saturday</option>
                                    <option value="sunday">Sunday</option>
                                </select>
                            </div>
                        </div>
                        <div class="inner-wrap">
                            <div class="buttons-type-multiselect">
                                <div class="item">
                                    <input
                                        type="radio"
                                        name="name1"
                                        class="rad"
                                        id="id-11"
                                        value="morning"
                                        v-model="filters.shift"
                                        @change="getListInfo"
                                    >
                                    <label for="id-11">
                                        <div class="ttl">1st (Morning)</div>
                                    </label>
                                </div>
                                <div class="item">
                                    <input
                                        type="radio"
                                        name="name1"
                                        class="rad"
                                        id="id-12"
                                        value="afternoon"
                                        v-model="filters.shift"
                                        @change="getListInfo"
                                    >
                                    <label for="id-12">
                                        <div class="ttl">2nd (Afternoon)</div>
                                    </label>
                                </div>
                                <div class="item">
                                    <input
                                        type="radio"
                                        name="name1"
                                        class="rad"
                                        id="id-13"
                                        value="night"
                                        v-model="filters.shift"
                                        @change="getListInfo">
                                    <label for="id-13">
                                        <span class="ttl">3rd (Overnight)</span>
                                    </label>
                                </div>
                            </div>
                            <a
                                v-if="possibilityToExport"
                                href="javascript:void(0)"
                                class="btn btn--outline-primary btn--middle"
                                @click="exportStandList">
                                <img src="/img/svg/excel.svg" alt="export">
                            </a>
                        </div>
                    </div>
                    <div class="buttons--row">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click="getListInfo">
                                <img src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                class="search--block-txt"
                                v-model="filters.search"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap" style="min-width: 40%">
                            <label for="" class="reg-label mr-2">Stages:</label>
                            <div class="form-group form-group-2 mb-0" style="flex-grow: 1">
                                <select
                                    class="custom-select"
                                    v-model="filters.stage"
                                    @change="getListInfo"
                                >
                                    <option value="all">Select One</option>
                                    <option
                                        v-for="stage in listOfStages"
                                        :key="stage.id"
                                        :value="stage.id"
                                    >{{stage.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th colspan="2">
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('name')"> Name<i
                                            class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>Tags</th>
                                <th>Availability</th>
                                <th>Last Update</th>
                                <th>Notes</th>
                                <th>Location</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="applicant in standByList"
                                :key="applicant.id"
                            >
                                <td class="color--text">
                                    <a :href="`/master-admin/applicants/${applicant.id}/show`">
                                        <b>{{ applicant.name }} {{ applicant.last_name }}</b>
                                    </a>
                                    <div class="small-text color--text">
                                        {{ applicant.status }}
                                    </div>
                                </td>
                                <td class="avatar-col"></td>
                                <td>
                                    <div class="tags-list" v-if="applicant.tags.length > 0">
                                        <div class="tag-wrap">
                                            {{ applicant.tags[0].name ?? '' }}
                                        </div>
                                        <a class="action-link dropdown-toggle" data-toggle="dropdown"
                                           href="#"><b>{{ applicant.tags.length }}</b> tags</a>
                                        <div class="dropdown-menu">
                                            <div class="tags-wrap">
                                                <div class="tag-item" v-for="tag in applicant.tags">{{ tag.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else></div>
                                </td>
                                <td>
                                    {{ (showAvailableShift(applicant) + ' shift') ?? '' }}
                                </td>
                                <td>
                                    <div class="color--text-gray">
                                        {{ calculateDate(applicant.availability.updated_at) }}
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span
                                            v-show="applicant.stand_by_list_comment && activeApplicant.id !== applicant.id">{{applicant.stand_by_list_comment }}</span>
                                        <div
                                            v-show="!applicant.stand_by_list_comment && activeApplicant.id !== applicant.id"
                                            class="form-group form-group-1 mb-0 "
                                            style="min-width: 19rem">
                                            <input type="text" class="form-control" readonly placeholder="Add Comment">
                                        </div>
                                        <div
                                            v-show="activeApplicant.id === applicant.id"
                                            class="form-group form-group-1 mb-0 "
                                            style="min-width: 19rem">
                                            <input type="text" class="form-control"
                                                   v-model="applicant.stand_by_list_comment">
                                        </div>


                                        <a v-if="activeApplicant.id === applicant.id "
                                           href="javascript:void(0)"
                                           class="edit-link ml-2"
                                           @click="updateComment(applicant)">
                                            <img src="/img/svg/check-5.svg" alt="save">
                                        </a>
                                        <a
                                            v-else
                                            href="javascript:void(0)"
                                            class="edit-link ml-2"
                                            @click="editComment(applicant)">
                                            <img src="/img/svg/icons-pen.svg" alt="edit">
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    {{ applicant.user_address?.address }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        class="ml-3 mr-3"
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import StandByListService from "./services/StandByListService";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import AvailabilityHandler from "../../../../../resources/js/mixins/AvailabilityHandler";
import ExportHandler from "../../../../../resources/js/mixins/ExportHandler";
import StatusService from "../../../Status/resources/js/services/StatusService";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'StandByList',
    components: {Pagination},
    mixins: [
        DateConverter,
        PaginationHandler,
        SortDirectionHandler,
        AvailabilityHandler,
        ExportHandler,
    ],
    props: {
        possibilityToExport: {
            type: Boolean,
            required: true
        } ,
    },
    data() {
        return {
            listOfStages: null,
            activeApplicant: {},
            export_stands: [],
            loading: true,
            stand_comment: null,
            standByList: [],
            filters: {
                stage: 'all',
                shift: 'morning',
                sortBy: 'name',
                day: 'all',
                sortDir: 'asc',
                search: '',
                page: 1,
                perPage: 10,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },

    methods: {
        async getListOfStages() {
            try {
                const {data : response } = await StatusService.getListOfStatuses()
                this.listOfStages = response
            } catch (e) {
                this.$showErrorMessage('Filter by status does not work\n' +
                    'Try again')
            }
        },
        getList(filters) {
            this.getListInfo(filters)
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        editComment(applicant) {
            this.activeApplicant = applicant
        },
        async exportStandList() {
            this.export_stands = this.standByList.map(applicant => (applicant.id))
            const dataToSend = {
                'export_stands': this.export_stands,
                'day': this.filters.day,
                'shift': this.filters.shift,
                'stage': this.filters.stage,
            };
            try {
                const response = await StandByListService.exportStands(dataToSend)
                this.createExportFile(response, 'stand_by_list_')

            } catch (error) {
                console.error(error)
                this.$showErrorMessage();
            }
        },
        async getListInfo() {
            try {
                const {data: list} = await StandByListService.getList(this.filters);
                this.standByList = list.data
                this.pagination.current_page = list.current_page
                this.pagination.last_page = list.last_page
                this.loading = false

            } catch (e) {
                this.$showErrorMessage();
            }
        },
        async updateComment(applicant) {
            this.$showLoadingMessage()
            try {
                const {data: updatedApplicant} = await StandByListService.updateComment(applicant.id, applicant.stand_by_list_comment);
                this.activeApplicant.stand_by_list_comment = applicant.stand_by_list_comment;
                this.activeApplicant = {};
                this.$showSuccessMessage('Your Comment was updated!');
                await this.getListInfo();

            } catch (e) {
            }
        },

    },
    mounted() {
        this.getListInfo()
        this.getListOfStages()
        this.delayedSearch = createDebouncedFunction(() => this.getListInfo(), 500);
    }
}

</script>

<style scoped>

</style>
